/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Row, Col, Input } from 'reactstrap';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';
import { addOrderAddress, updateOrderAddress } from '../../../actions/order';
import AutoComplete from '../autoComplete';
import {
  getLocationSuggestion,
  getLocationSuggestionDetail,
} from '../../../api/map';
import Order09PathStaticMap from './Order09PathStaticMap';
import { localStorageGet } from '../../../service/localStorage';
import { v4 as uuidv4 } from 'uuid';

import imgClear from '../../../assets/img/icon_clear_2.png';
import imgClear2 from '../../../assets/img/icon_clear_2@2x.png';
import imgFrom from '../../../assets/img/icon_from.png';
import imgFrom2 from '../../../assets/img/icon_from@2x.png';
import imgMid from '../../../assets/img/icon_mid.png';
import imgMid2 from '../../../assets/img/icon_mid@2x.png';
import imgTo from '../../../assets/img/icon_to.png';
import imgTo2 from '../../../assets/img/icon_to@2x.png';


let address = {
  address: '',
  lat: 0,
  lon: 0,
};

class Order09PathComponent extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    address: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.string,
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),
    ).isRequired,
    addOrderAddress: PropTypes.func.isRequired,
    updateOrderAddress: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      address: '',
      autoCompleteSuggestion: [],
      openModal: false,
      activeSuggestion: {},
      addresses: localStorageGet('addresses', false),
      googleMapSessionToken: null
    };
    this.onhandleLocationChange = this.onhandleLocationChange.bind(this);
    this.onClickSelectSuggestion = this.onClickSelectSuggestion.bind(this);
    this.onGetLocationSuggestionDetail = this.onGetLocationSuggestionDetail.bind(
      this,
    );
    this.onClickToggleStaticMap = this.onClickToggleStaticMap.bind(this);
    this.checkOrderAddressItem = this.checkOrderAddressItem.bind(this);
    this.onClickClearAddress = this.onClickClearAddress.bind(this);
  }

  componentWillMount() {
    if (
      localStorageGet('addresses', false) !== null &&
      this.state.addresses.waypoints.length > this.props.index
    ) {
      // this.props.updateOrderAddress(
      //   addresses[`address${this.props.index + 1}`],
      //   this.props.index,
      // );
      this.setState({
        address: this.state.addresses.waypoints[this.props.index].address,
      });
      // in
      this.setState({
        activeSuggestion: {
          geometry: {
            location: {
              lat: this.state.addresses.waypoints[this.props.index].location
                .lat,
              lng: this.state.addresses.waypoints[this.props.index].location
                .lon,
            },
          },
        },
      });
    }
  }

  onClickClearAddress(index) {
    this.setState({ address: '' });
    this.props.updateOrderAddress({ address: '', lat: 0, lon: 0 }, index);
  }

  onClickSelectSuggestion(suggestion, index) {
    this.setState({ address: suggestion.description });
    this.setState({ autoCompleteSuggestion: [] });
    this.onGetLocationSuggestionDetail(suggestion.place_id, index);
  }

  onGetLocationSuggestionDetail(placeID, index) {
    getLocationSuggestionDetail(placeID, this.props.currentLocale, this.state.googleMapSessionToken)
      .then(response => response.json())
      .then(result => {
        this.setState({ activeSuggestion: result.result });
        address = {
          address: result.result.formatted_address,
          lat: result.result.geometry.location.lat,
          lon: result.result.geometry.location.lng,
        };
        this.checkOrderAddressItem(address, index);
      })
      .catch(error => {
        console.warn('Request failed', error);
      })
      .finally(() => {
        this.setState({ googleMapSessionToken: null })
      });
  }

  onhandleLocationChange(e) {
    const sessionToken = this.state.googleMapSessionToken === null ? uuidv4() : this.state.googleMapSessionToken
    this.setState({
      address: e.target.value,
      googleMapSessionToken: sessionToken
    });
    getLocationSuggestion(e.target.value, this.props.currentLocale, sessionToken)
      .then(response => response.json())
      .then(result => {
        this.setState({ autoCompleteSuggestion: result.predictions });
      })
      .catch(error => {
        console.warn('Request failed', error);
      });
    this.forceUpdate();
  }

  onClickToggleStaticMap(bool) {
    this.setState({ openModal: bool });
  }

  // Check if add address or update address
  checkOrderAddressItem(addresses, index) {
    if (this.props.address.length < index) {
      this.props.addOrderAddress(addresses);
    } else {
      this.props.updateOrderAddress(addresses, index);
    }
  }

  render() {
    const { index } = this.props;
    let imgTag = '';
    let imgTag2 = '';
    let imgClass = '';
    let imgPlaceholder = this.props.modelDataText
      .order_option_route_location_2_address_input;
    if (index === 0) {
      imgTag = imgFrom;
      imgTag2 = imgFrom2;
      imgClass = s2.routeStartImg;
      imgPlaceholder = this.props.modelDataText
        .order_option_route_location_1_address_input;
    } else if (index < this.props.address.length - 1) {
      imgTag = imgMid;
      imgTag2 = imgMid2;
      imgClass = s2.routeMidImg;
    } else {
      imgTag = imgTo;
      imgTag2 = imgTo2;
      imgClass = s2.routeEndImg;
    }
    return (
      <Row key={index}>
        <Col md="10" xs="10">
          <Input
            className={`${s2.iconLeft}`}
            placeholder={imgPlaceholder}
            id={index}
            onChange={this.onhandleLocationChange}
            onBlur={() => {
              setTimeout(() => {
                this.setState({ autoCompleteSuggestion: [] });
              }, 200);
            }}
            value={this.state.address}
          />
          <AutoComplete
            suggestion={this.state.autoCompleteSuggestion}
            onClickSelectSuggestion={this.onClickSelectSuggestion}
            index={index}
          />
          <img
            className={`${s2.imgIconLeft} ${imgClass}`}
            srcSet={`${imgTag} 1x, ${imgTag2} 2x`}
            width="13"
            alt="start"
          />
          {this.state.address === '' ? (
            ''
          ) : (
            <span
              role="button"
              tabIndex={0}
              onClick={() => {
                this.onClickClearAddress(index);
              }}
              onKeyPress={() => {}}
            >
              <img
                className={`${s2.inputClear}`}
                srcSet={`${imgClear} 1x, ${imgClear2} 2x`}
                width="24"
                height="24"
                alt="clear"
              />
            </span>
          )}
        </Col>
        <Col md="2" xs="2" className={`${s2.orderLocationCellViewMap}`}>
          <span
            role="button"
            tabIndex={0}
            onClick={e => {
              if (
                typeof this.props.address[index] !== 'undefined' &&
                this.props.address[index].address !== ''
              ) {
                this.onClickToggleStaticMap(true);
                e.preventDefault();
              }
            }}
            onKeyPress={() => {}}
            className={`${
              typeof this.props.address[index] === 'undefined' ||
              this.props.address[index] === '{}' ||
              this.props.address[index].address === ''
                ? s2.disabled
                : [s2.orderFunctionText, s.textBlue].join(' ')
            }`}
          >
            <span className={s.hideMobile}>
              {this.props.modelDataText.order_option_route_view_on_map_button}
            </span>
            <span className={s.showMobile}>
              {
                this.props.modelDataText
                  .order_option_route_view_on_map_button_mobile
              }
            </span>
          </span>
          <Order09PathStaticMap
            openModal={this.state.openModal}
            onClickToggleStaticMap={this.onClickToggleStaticMap}
            activeSuggestion={this.state.activeSuggestion}
          />
        </Col>
      </Row>
    );
  }
}
const mapState = state => ({
  address: state.order.address,
  currentLocale: state.intl.locale,
});

const mapDispatch = {
  addOrderAddress,
  updateOrderAddress,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s)(Order09PathComponent),
);



// WEBPACK FOOTER //
// ./src/routes/order/order09Path/Order09PathComponent.js